import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LevelAsset, AssetsDataService, ILevelAsset } from '@services/assets-data.service';
import { EditHierarchyAssetComponent } from '@dialogs/edit-level-asset/edit-level-asset.component';
import { Subject, distinctUntilChanged, filter, finalize, firstValueFrom, takeUntil } from 'rxjs';
import { GlobalFunctions, SnackType, imagePath, imgTypes } from '@global/GlobalFunctions';
import { IOrganisationsHierarchy, OrganisationDataService } from '@services/organisation-data.service';
import { siteSubscriptions } from '@services/siteSubscriptions';

/**
 * Component
 */
@Component({
	selector: 'app-hierarchy-asset',
	templateUrl: './hierarchy-asset.component.html',
	styleUrls: ['./hierarchy-asset.component.scss']
})
export class HierarchyAssetComponent {

	/** Path to Assets Images */
	public imagePathAssets(): string {
		return imagePath(this.accountID, imgTypes.organisationassets).toLowerCase()
	}

	/** asset */
	@Input() asset: LevelAsset
	/** accountID */
	@Input() accountID: string;
	/** OrganisationID */
	@Input() OrganisationID: string;
	/** selected */
	@Output() selected: EventEmitter<ILevelAsset> = new EventEmitter<ILevelAsset>();

	/**
	 * Default Constructor
	 * @param dialog dialog
	 * @param assetsData assetsDataService
	 * @param organisationDataService OrganisationDataService
	 * @param globalFunctions globalFunctions
	 * @param siteSubscriptions siteSubscriptions
	 */
	constructor(
		public dialog: MatDialog,
		private assetsData: AssetsDataService,
		private organisationDataService: OrganisationDataService,
		private globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions
	) { }

	/**
	 * triggerEvent
	 * @param Asset
	 */
	triggerEvent(Asset: ILevelAsset) {
		// Optionally, you can pass data along with the event
		const eventData: ILevelAsset = Asset;
		this.selected.emit(eventData);
	}

	/**
	 * Edit the Company details
	 * @param editAsset
	 */
	editAsset(editAsset: ILevelAsset): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...editAsset };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.assetsData.patchOrganisationAssets$(this.accountID, this.OrganisationID, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					Object.assign(editAsset, result);
					this.rebuildOrganisationStructure(this.accountID, this.OrganisationID)
					this.globalFunctions.DisplaySnackBar({
						message: "Asset Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}
			});
		});
	}

	/**
	 * Get the Organisation Structure
	 * @param AccountID AccountID
	 * @param OrganisationID OrganisationID
	 */
	async rebuildOrganisationStructure(AccountID: string, OrganisationUID: string) {
		try {
			let structure = await firstValueFrom(
				this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID)
					.pipe(filter((response) => !!response)));
			if (structure) {
				var OrganisationStructure = <IOrganisationsHierarchy[]>JSON.parse(structure);
				this.siteSubscriptions.SethierarchicalData(OrganisationStructure);
			}
		}
		catch (error: any) {
			if (error["status"] != 404) {
				this.globalFunctions.HandleError(error, "Error: this.organisationDataService.getOrganisationStructure$", false)
			}
		}
	}
}
